import React,{useState} from 'react'
import UploadIcon from '@mui/icons-material/Upload';
import {
  Search,

} from "@mui/icons-material";
import './Header.css'
import {

  Button,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";
import FormControl from '@mui/material/FormControl';
import {useNavigate,useParams} from 'react-router-dom'

import { Box } from '@mui/system'


const Header = ({ handleUpload,performSearch }) => {
  const params = useParams();
  const Navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [timeoutDebounce, setTimeoutDebounce] = useState(0);
  const hello = () => {
    Navigate("/");
  }
  const debounceSearch = (event, debounceTimeout) => {
    console.log("debounce running");

    if (timeoutDebounce !== 0) {
      clearTimeout(timeoutDebounce);
    }
    let timerId = setTimeout(
      () => performSearch(event.target.value),
      debounceTimeout
    );
    setTimeoutDebounce(timerId);
    setSearch(event.target.value);
    //console.log(search);
    //console.log("debounce am running");
  };


  return (
    <div>
      <Box className="header" bgcolor="primary.dark">
        <Button variant="text" onClick={hello}>
          <h1 style={{ "textShadow": "2px 2px 5px red, 0 0 25px blue, 0 0 5px darkblue", color: "red", margin: 0 }}>X</h1> 
          <h1 style={{ color: "white", margin:0, "marginLeft":"0.3rem" }}>Flix</h1>
        </Button>
                {
          !params.id &&
          
        <FormControl sx={{ m: 1, width: '45ch' }} variant="outlined" size="small">
          <OutlinedInput
            id="outlined-adornment-weight"
            value={search}
            onChange={(e) => debounceSearch(e, 500)}
            endAdornment={<InputAdornment position="end"><Button disabled varient="text" startIcon={<Search/>}>Search</Button></InputAdornment>}
            aria-describedby="outlined-weight-helper-text"
            inputProps={{
              'aria-label': 'weight',
            }}
            />
         
        </FormControl>
          }
     
        {
          !params.id && 
        <Button variant="contained" color="error" startIcon={<UploadIcon/>} onClick={()=>handleUpload()}>
          Upload
        </Button>
        }




      </Box>
    </div>
  )
}

export default Header